import { render, staticRenderFns } from "./SalesPerformance.vue?vue&type=template&id=75004958&scoped=true"
import script from "./SalesPerformance.vue?vue&type=script&lang=js"
export * from "./SalesPerformance.vue?vue&type=script&lang=js"
import style0 from "./SalesPerformance.vue?vue&type=style&index=0&id=75004958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75004958",
  null
  
)

export default component.exports